'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getEndpoint = require('./getEndpoint');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getEndpoint).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/get-endpoint/index.js
// module id = 49
// module chunks = 0